module.exports = __webpack_public_path__ + "img/16.1253cc84.png";